<template>
  <i-modal width="440"
           class="fineart-qr-code"
           :value="isShowed"
           @on-visible-change="changeHandler"
           footer-hide>
    <h3 class="name">
      <slot name="name"></slot>
    </h3>
    <section class="img-wrap">
      <slot name="img"></slot>
    </section>
    <section class="tips">
      <slot name="tip">手机扫码查看</slot>
    </section>
  </i-modal>
</template>

<script>
import { Modal } from 'iview'

export default {
  name: 'FineartQrCode',
  components: {
    'i-modal': Modal
  },
  data () {
    return {
    }
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'isShowed',
    event: 'change'
  },
  methods: {
    changeHandler (show) {
      this.$emit('change', show)
    },
    closeFunc () {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="stylus">
.fineart-qr-code
  .ivu-modal-content
    padding-top: 74px
    padding-bottom: 10px
    border-radius: 12px
  .name
    font-size: 22px
    line-height: 30px
    color: $black1
    text-align: center
    font-weight: 500
    margin-bottom: 20px
    {ellipse}
    &:empty
      display: none
  .img-wrap
    width: 242px
    margin: 0 auto
    img
      width: 100%
  .tips
    font-size: 18px
    line-height: 25px
    color: $orange
    font-weight: 400
    text-align: center
    margin-top: 20px
    &:empty
      display: none
</style>



// WEBPACK FOOTER //
// src/components/FineartQrCode.vue